import { Component } from '@eppendorf/vnls-device-service-utils';

import {
  applyFractionDigits,
  createValueElement,
} from '$features/monitoring/shared/formatting.utils';

export interface Props {
  shadowComp: Component;
  threshValue: string | null;
}

export function ThresholdStaticValueLabelSnapshot({ shadowComp, threshValue }: Props) {
  return `${createValueElement(applyFractionDigits(shadowComp.fractionalDigits), shadowComp.valueType, `${threshValue}`)} ${shadowComp.unit}`;
}
